import React, { FC } from 'react';
import styled from 'styled-components';

interface LineClampTextProps {
    lines?: string;
    content?: string;
}

const StyledParagraph = styled.p<LineClampTextProps>`
  margin: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${props => props.lines || '1'};
`;

const LineClampText: FC<LineClampTextProps> = ({ lines, content }) => {
    return (
        <div>
            <StyledParagraph lines={lines}>
                {content}
            </StyledParagraph>
        </div>
    );
};

export default LineClampText;
